import React from 'react';
import { Box, Typography, Breadcrumbs, Link as MuiLink, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import brandingConfig from '../../config/brandingConfig';

const HeaderContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2, 0),
}));

const TitleRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.primary,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: parseInt(brandingConfig.ui.borderRadius),
  backgroundColor: brandingConfig.colors.primary,
  color: '#000000', // Schwarze Schrift
  '&:hover': {
    backgroundColor: brandingConfig.colors.primary,
    filter: 'brightness(90%)'
  }
}));

const BreadcrumbLink = styled(MuiLink)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const PageHeader = ({ 
  title, 
  breadcrumbs = [], 
  actionButton = null,
  secondaryButton = null, 
  description = null 
}) => {
  return (
    <HeaderContainer>
      <TitleRow>
        <PageTitle variant="h4">
          {title}
        </PageTitle>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {secondaryButton && (
            <ActionButton 
              variant="outlined" 
              color="primary" 
              startIcon={secondaryButton.icon}
              onClick={secondaryButton.onClick}
              component={secondaryButton.path ? Link : undefined}
              to={secondaryButton.path}
            >
              {secondaryButton.label}
            </ActionButton>
          )}
          {actionButton && (
            <ActionButton 
              variant="contained" 
              color="primary" 
              startIcon={actionButton.icon}
              onClick={actionButton.onClick}
              component={actionButton.path ? Link : undefined}
              to={actionButton.path}
            >
              {actionButton.label}
            </ActionButton>
          )}
        </Box>
      </TitleRow>
      
      {breadcrumbs.length > 0 && (
        <Breadcrumbs 
          separator={<NavigateNextIcon fontSize="small" />} 
          aria-label="breadcrumb"
          sx={{ mb: 1 }}
        >
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            
            return isLast ? (
              <Typography key={index} color="text.primary">
                {crumb.label}
              </Typography>
            ) : (
              <BreadcrumbLink
                key={index}
                component={Link}
                to={crumb.path}
                underline="hover"
              >
                {crumb.label}
              </BreadcrumbLink>
            );
          })}
        </Breadcrumbs>
      )}
      
      {description && (
        <Typography variant="body1" color="text.secondary">
          {description}
        </Typography>
      )}
    </HeaderContainer>
  );
};

export default PageHeader;